function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("linearGradient", {
  id: "big-blob_svg__a",
  gradientUnits: "userSpaceOnUse",
  x1: 265.205,
  y1: 895.36,
  x2: 514.605,
  y2: -625.492,
  gradientTransform: "matrix(1 0 0 -1 0 622.944)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3eb883"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M161.9 574.5c2-11 5.7-22.8 11.4-35.2 19-41.9 52.3-82.4 54.4-130 2.9-67-58.4-87.6-113.2-100.7-37.9-9-79.4-21.1-100.2-54.1C-8.5 218.4 2.9 169.1 28.6 135 124.3 8.3 307-14.2 452.4 12c62.1 11.2 123.2 35.9 168.9 79.4 157.6 150 20.5 385.2-108.3 500.3-48.3 43.1-102.2 82.9-164.9 98.8-91.1 23.1-203.8-19.5-186.2-116z",
  fill: "url(#big-blob_svg__a)"
});

function SvgBigBlob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 694 699"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2OTQgNjk5Ij48bGluZWFyR3JhZGllbnQgaWQ9ImEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iMjY1LjIwNSIgeTE9Ijg5NS4zNiIgeDI9IjUxNC42MDUiIHkyPSItNjI1LjQ5MiIgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAtMSAwIDYyMi45NDQpIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNmMmY1ZmEiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMzZWI4ODMiLz48L2xpbmVhckdyYWRpZW50PjxwYXRoIGQ9Ik0xNjEuOSA1NzQuNWMyLTExIDUuNy0yMi44IDExLjQtMzUuMiAxOS00MS45IDUyLjMtODIuNCA1NC40LTEzMCAyLjktNjctNTguNC04Ny42LTExMy4yLTEwMC43LTM3LjktOS03OS40LTIxLjEtMTAwLjItNTQuMUMtOC41IDIxOC40IDIuOSAxNjkuMSAyOC42IDEzNSAxMjQuMyA4LjMgMzA3LTE0LjIgNDUyLjQgMTJjNjIuMSAxMS4yIDEyMy4yIDM1LjkgMTY4LjkgNzkuNCAxNTcuNiAxNTAgMjAuNSAzODUuMi0xMDguMyA1MDAuMy00OC4zIDQzLjEtMTAyLjIgODIuOS0xNjQuOSA5OC44LTkxLjEgMjMuMS0yMDMuOC0xOS41LTE4Ni4yLTExNnoiIGZpbGw9InVybCgjYSkiLz48L3N2Zz4=";
export { SvgBigBlob as ReactComponent };